export default __webpack_public_path__ + "static/media/Class-10-State-Hindi.5aecfde5.pdf";